import { useAsync } from '@tiger/hooks';
import React from 'react';
import { Outlet } from 'react-router-dom';
import ErrorBox from 'components/ErrorBox';
import Loading from 'components/Loading';
import security from 'stores/security';

const Ach: React.FC = () => {
    // 获取用户是否开启了两步认证
    const [{ loading, error }, getData] = useAsync(() => security.getOtpStatus());

    if (loading) {
        return <Loading />;
    }

    if (error) {
        return <ErrorBox error={error} onClick={getData} />;
    }

    return (
        <div className="deposit-ach-root">
            <Outlet />
        </div>
    );
};

export default Ach;
